/**
 * 外部链接配置
 *
 * 集中管理所有外部链接和品牌信息
 */

// ============================================
// Support & Contact
// ============================================

// TODO: 后续配置自定义域名邮箱后，改为 support@studyjoyful.com
export const SUPPORT_EMAIL = 'aquila.lab.sg@gmail.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=帮助与反馈`;

// ============================================
// Legal & Policy (Internal routes - public pages)
// ============================================

export const PRIVACY_POLICY_URL = '/privacy';
export const TERMS_OF_SERVICE_URL = '/terms';

// ============================================
// Brand & Company
// ============================================

export const COMPANY_NAME = 'Aquila Lab Pte. Ltd.';
export const COMPANY_WEBSITE = 'https://studyjoyful.com';

// ============================================
// App Info
// ============================================

export const APP_VERSION = '1.0.0';
export const APP_NAME = 'StudyJoyful';
export const APP_TAGLINE = 'Joyful Learning Starts Here';

// ============================================
// Aggregated Exports
// ============================================

export const ExternalLinks = {
  support: {
    email: SUPPORT_EMAIL,
    mailto: SUPPORT_MAILTO,
  },
  legal: {
    privacy: PRIVACY_POLICY_URL,
    terms: TERMS_OF_SERVICE_URL,
  },
  brand: {
    company: COMPANY_NAME,
    website: COMPANY_WEBSITE,
  },
} as const;
